import { gql } from "@apollo/client";

export const GET_CUSTOM_FORM_BY_TYPE = gql`
  query getConsumerCustomFormType(
    $organisationId: String!
    $formType: String!
    $atBranchLevel: Boolean
  ) {
    getConsumerCustomFormType(
      organisationId: $organisationId
      formType: $formType
      atBranchLevel: $atBranchLevel
    ) {
      id
      formType
      isDefault
      organisationId
      branchId
      atBranchlevel
      config {
        webApp {
          fields {
            name
            key
            isMandatory
            isEditable
            isVisible
          }
          customQuestions {
            id
            questionText
            questionType
            isRequired
            options
          }
        }
        website {
          fields {
            name
            key
            isMandatory
            isEditable
            isVisible
          }
          customQuestions {
            id
            questionText
            questionType
            isRequired
            options
            visibleToBusinessCustomer
          }
        }
      }
    }
  }
`;